import HomeIcon from "./HomeIcon";
import ReservationIcon from "./ReservationIcon";
import MyVehiclesIcon from "./MyVehiclesIcon";
import MyDriversIcon from "./MyDriversIcon";

const NavIcons = { HomeIcon, ReservationIcon, MyVehiclesIcon, MyDriversIcon };

export default NavIcons;
